/* export const calculateAccuracy = (
	responses: number,
	population: number, // invited
	score: number,
) => {
	const Z = 1.96;
	const p = score / 100;
	const variance = (p * (1 - p)) / responses;
	const finitePopulationCorrection =
		(population - responses) / (population - 1);
	const marginOfError = Z * Math.sqrt(variance * finitePopulationCorrection);

	return marginOfError;
}; */

export const calculateAccuracy = (successes: number, submitted: number) => {
	const z = 1.96;
	const adjX = successes + (z * z) / 2;
	const adjN = submitted + z * z;
	const p = adjX / adjN;
	const q = 1 - p;

	const marginOfError = z * Math.sqrt((p * q) / adjN);
	return marginOfError;
};
